import { useMemo } from 'react';
import { DateTime } from 'luxon';

export const useGetImportantDays = () => {
  return useMemo(() => {
    const today = DateTime.local().startOf('day').toISO();
    const tomorrow = DateTime.local().plus({ day: 1 }).startOf('day').toISO();
    const dayAfterTomorrow = DateTime.local().plus({ day: 2 }).startOf('day').toISO();
    const [startWeek, endWeek] = [DateTime.local().startOf('week').toISO(), DateTime.local().endOf('week').toISO()];
    return { today, tomorrow, dayAfterTomorrow, startWeek, endWeek };
  }, []);
};
